<template>
  <div id="updateProcess" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/BrandMerchandise' }">品牌商品库</el-breadcrumb-item>
      <el-breadcrumb-item>关键词入库</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page" style="margin-bottom: 10px;min-height: 700px;" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-input clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="q" placeholder="请输入关键词" size="small" style="width: 400px;"></el-input>
      <el-button size="small" class="search-btn" style="margin-left: 20px;" @click="get_pdd_list(1)">查询</el-button>
      <div style="margin-top: 30px;">
        <el-row>
						<el-col :span="4" v-for="item in tableData">
							<div style="background-color: white;border-radius: 20px;margin: 7px;padding: 15px;height: 400px;border: 1px solid #ebeef5;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);">
                <div style="float: left;width: 100%;">
                  <el-button type="info" size="mini" style="margin-bottom: 10px;float: left;" v-show="item.isPlugin == 'n' && item.iprNoneed == false && !item.fastStockIn">
                    未入库
                  </el-button>
                  <el-button
										type="danger"
										size="mini"
                    style="margin-bottom: 10px;float: left;margin-left: 0px;"
										v-show="Number(item.fastStockInStatus) === 2 || Number(item.fastStockInStatus) === 3"
										>快速入库异常</el-button
									>
      						<el-button
      							size="mini"
                    type="primary"
                    style="margin-bottom: 10px;float: left;margin-left: 0px;"
      							v-show="item.isPlugin == 'y' && item.isupdate !== 0"
      							>已入库</el-button
      						>
      						<el-button
      							size="mini"
                    style="margin-bottom: 10px;float: left;margin-left: 0px;"
      							type="danger"
      							v-show="item.status && item.status == '下架'"
      							>下架</el-button
      						>
      						<el-button
      							size="mini"
                    style="margin-bottom: 10px;float: left;margin-left: 0px;"
      							type="danger"
      							v-show="item.status && item.status == '链接失效'"
      							>链接失效</el-button
      						>
      						<el-button
      							size="mini"
                    type="success"
                    style="margin-bottom: 10px;float: left;margin-left: 0px;"
      							v-show="item.isPlugin == 'n' && item.fastStockIn && Number(item.fastStockInStatus) !== 2 && Number(item.fastStockInStatus) !== 3"
      							>快速入库</el-button
      						>
                  <span
                    v-show="item.isPlugin && item.iprNoneed == 0"
    								class="move-in"
    								size="mini"
                    @click="fastStockIn(item)"
    							></span>
                </div>

                <img :src="item.logopicurl" alt="暂无图片" style="width: 228px;height: 228px;" />
                <div>
                  <span style="color: #151516;">
                    {{item.itemtitle}}
                  </span>
								</div>
                <div>
                  <span style="color: #e02e24;font-size: 20px;">
                    ¥{{item.price}}
                  </span>
								</div>
                <div>
                  店铺名称：{{item.shopname}}
								</div>
							</div>
						</el-col>
        </el-row>
        <div class="nodata" style="height: 700px;line-height: 700px;" v-if="tableData.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
      </div>
    </div>
    <div style="width: 100%;text-align: center;">
      <el-button size="small" @click="get_pdd_list('上一页')" v-if="moreShow && page != 1">上一页</el-button>
      <el-button size="small" @click="get_pdd_list('下一页')" v-if="moreShow && tableData.length != 0">下一页</el-button>
    </div>

  </div>
</template>

<script>
  import aes from "../../../libs/aes";
  import pagination from "../../../components/dataTable/pagination";
  export default {
    data() {
      return {
        q: '',
        page: 1,
        tableData: [],
        moreShow: false,
        loading: false,
        platform: "",
      }
    },
    mounted() {
      this.platform = this.$route.query.platform
    },
    methods: {
      // 爬虫关键词
      get_pdd_list(e) {
        if (!this.q) {
          this.$message({
            message: '请输入关键词',
            type: 'warning'
          });
          return;
        }
        if (e == 1) {
          this.page = 1
        } else if (e == '下一页') {
          console.log(this.page)
          this.page = Number(this.page) + 1
        } else {
          this.page = Number(this.page) - 1
        }
        this.loading = true
        let params = {
          bmcid: localStorage.getItem('bmcKefuid'),
          q: this.q,
          page: this.page,
          platform: this.platform
        }
        fetch({
          url: "/get_keyword_list",
  				method: "post",
  				data: JSON.stringify(params),
  				headers: {
  					'Content-Type': 'application/json',
  				},
  				noFormat: false,
  				responseType: "json"
        }).then(result => {
          let res = result;
          if(res.status == '200') {
            this.page = res.page
            this.moreShow = true
            this.getListByPluginList(res.data)
          } else if (res.status == '400') {
            this.tableData = []
            this.moreShow = false
            this.$message({
              message: '暂无数据',
              type: 'warning'
            });
            this.loading = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 用严旭的爬虫数据去调用杰哥的后台数据
      getListByPluginList(dlData,type) {
        let arrData = []
        for (let a in dlData) {
          arrData.push({
            itemid: dlData[a].itemid,
            platform: this.platform,
            whitename: dlData[a].shopname,
          })
        }
        fetch({
          url: "hcm/iprNewPluginList/getListByPluginList",
  				method: "post",
          data: JSON.stringify(arrData),
  				headers: {
  					'Content-Type': 'application/json',
  				},
  				noFormat: false,
  				responseType: "json"
        }).then(result => {
          let res = result;
          if(res.status == '10000') {
            if (type && type == "快速入库") {
              for (let c in this.tableData) {
                if (res.data.pluginlists[0].itemid == this.tableData[c].itemid) {
                  this.tableData[c].camisreport = res.data.pluginlists[0].camisreport
                  this.tableData[c].fastStockIn = res.data.pluginlists[0].fastStockIn
                  this.tableData[c].fastStockInStatus = res.data.pluginlists[0].fastStockInStatus
                  this.tableData[c].iprNoneed = res.data.pluginlists[0].iprNoneed
                  this.tableData[c].iprPlugin = res.data.pluginlists[0].iprPlugin
                  this.tableData[c].isPlugin = res.data.pluginlists[0].isPlugin
                  this.tableData[c].isSpecial = res.data.pluginlists[0].isSpecial
                  this.tableData[c].isWhitename = res.data.pluginlists[0].isWhitename
                  this.tableData[c].ischange = res.data.pluginlists[0].ischange
                  this.tableData[c].islowprice = res.data.pluginlists[0].islowprice
                  this.tableData[c].isreview = res.data.pluginlists[0].isreview
                  this.tableData[c].isupdate = res.data.pluginlists[0].isupdate
                  this.tableData[c].itemid = res.data.pluginlists[0].itemid
                  this.tableData[c].notice_number = res.data.pluginlists[0].notice_number
                  this.tableData[c].platform = res.data.pluginlists[0].platform
                  this.tableData[c].shopname = res.data.pluginlists[0].shopname
                }
              }
            } else {
              this.tableData = []
              for (let a in dlData) {
                for (let b in res.data.pluginlists) {
                  if (dlData[a].itemid == res.data.pluginlists[b].itemid) {
                    this.tableData.push({
                      // 后台接口返回状态数据
                      camisreport: res.data.pluginlists[a].camisreport,
                      iprNoneed: res.data.pluginlists[a].iprNoneed,
                      iprPlugin: res.data.pluginlists[a].iprPlugin,
                      isPlugin: res.data.pluginlists[a].isPlugin,
                      isSpecial: res.data.pluginlists[a].isSpecial,
                      isWhitename: res.data.pluginlists[a].isWhitename,
                      ischange: res.data.pluginlists[a].ischange,
                      islowprice: res.data.pluginlists[a].islowprice,
                      isreview: res.data.pluginlists[a].isreview,
                      isupdate: res.data.pluginlists[a].isupdate,
                      itemid: res.data.pluginlists[a].itemid,
                      notice_number: res.data.pluginlists[a].notice_number,
                      platform: res.data.pluginlists[a].platform,
                      shopname: res.data.pluginlists[a].shopname,
                      fastStockIn: res.data.pluginlists[a].fastStockIn ? res.data.pluginlists[a].fastStockIn : false,
                      fastStockInStatus: res.data.pluginlists[a].fastStockInStatus ? res.data.pluginlists[a].fastStockInStatus : false,
                      // 严旭接口返回数据
                      area: dlData[a].area,
                      bmcid: dlData[a].bmcid,
                      couponsList: dlData[a].couponsList,
                      evaluateNum: dlData[a].evaluateNum,
                      dlDataitemid: dlData[a].itemid,
                      itemlink: dlData[a].itemlink,
                      itemtitle: dlData[a].itemtitle,
                      itemtype: dlData[a].itemtype,
                      logopicurl: dlData[a].logopicurl,
                      price: dlData[a].price,
                      salevolume: dlData[a].salevolume,
                      skuList: dlData[a].skuList,
                      status: dlData[a].status,
                      subheading: dlData[a].subheading,
                      wangwang: dlData[a].wangwang,
                    })
                  }
                }
              }
            }
            this.loading = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 快速入库
      fastStockIn(item) {
        let params = {
          itemid: item.itemid,
          itemlink: item.itemlink,
          platform: this.platform,
        }
        if (params.platform == 'DY') {
          params.shopname = item.shopname
        }
        let arr = []
        arr.push(params)
        fetch({
          url: "hcm/iprNewPluginList/fastStockIn",
          method: "post",
          data: JSON.stringify(arr),
          headers: {
            'Content-Type': 'application/json',
          },
          noFormat: false,
          responseType: "json"
        }).then(result => {
          let res = result;
          if(res.status == '10000') {
            this.$message({
              message: "快速入库成功",
              type: 'success'
            });
            let arr = []
            arr.push(item)
            this.getListByPluginList(arr,"快速入库")
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
    }
  }
</script>
<style scoped lang="scss">
  .page {
    padding: 20px;
    margin-top: 10px;
    background-color: white;
  }
  .move-in {
    display: inline-block;
  	vertical-align: middle;
  	height: 28px;
  	width: 28px;
  	background-position: center;
  	background-repeat: no-repeat;
  	cursor: pointer;
  	outline: none;
  	background-image: url('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/1599614875792_move-in.png');
    float: right;
  }
</style>
